import axios from 'axios'

export default {
    namespaced: true,
    state: {
        percents: [],
    },
    mutations: {
        CLEAR_DATA(state) {
            state.percents = []
        },
        FETCH_MWR(state, payload) {
            state.percents = payload
        },
        ADD_MWR(state, payload) {
            const index = state.percents.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.percents[index], payload)
            } else {
                state.percents.push(payload)
            }
        },
        EDIT_MWR(state, payload) {
            const index = state.percents.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.percents[index], payload)
            }
        },
        DEL_MWR(state, payload) {
            const index = state.percents.findIndex(
                item => item.id === payload
            )
            if (index !== -1) {
                state.percents.splice(index, 1)
            }
        },
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.percents.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/root/max-wage-reduction'
                    ).then(({data}) => {
                        commit('FETCH_MWR', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        fetchFromRole({commit, dispatch}, filter) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/root/max-wage-reduction/get-percent-from-role',
                    { params: filter }
                ).then(({data}) => {
                    commit('FETCH_MWR', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/max-wage-reduction',
                    data
                ).then(({data}) => {
                    commit('ADD_MWR', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/max-wage-reduction/' + data.id,
                    data
                ).then(({data}) => {
                    commit('EDIT_MWR', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/max-wage-reduction/' + itemId,
                ).then(() => {
                    commit('DEL_MWR', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}
